import '@shoelace-style/shoelace/dist/themes/light.css';

import { Module } from '@rxdi/core';
import SlBreadCrumb from '@shoelace-style/shoelace/dist/components/breadcrumb/breadcrumb';
import SlBreadCrumbItem from '@shoelace-style/shoelace/dist/components/breadcrumb-item/breadcrumb-item';
import SlButton from '@shoelace-style/shoelace/dist/components/button/button';
import SlCard from '@shoelace-style/shoelace/dist/components/card/card';
import SlIcon from '@shoelace-style/shoelace/dist/components/icon/icon';
import SlIconButton from '@shoelace-style/shoelace/dist/components/icon-button/icon-button';
import SlMenu from '@shoelace-style/shoelace/dist/components/menu/menu.js';
import SlMenuItem from '@shoelace-style/shoelace/dist/components/menu-item/menu-item';
import SlSkeleton from '@shoelace-style/shoelace/dist/components/skeleton/skeleton';
import SlSpinner from '@shoelace-style/shoelace/dist/components/spinner/spinner';
import SlSwitch from '@shoelace-style/shoelace/dist/components/switch/switch';
import SlTooltip from '@shoelace-style/shoelace/dist/components/tooltip/tooltip';
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library';

registerIconLibrary('default', {
  resolver: (name) => `https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.20.1/dist/assets/icons/${name}.svg`,
});

@Module({
  components: [
    SlBreadCrumb,
    SlBreadCrumbItem,
    SlCard,
    SlIconButton,
    SlIcon,
    SlButton,
    SlSkeleton,
    SlMenu,
    SlMenuItem,
    SlSwitch,
    SlSpinner,
    SlTooltip,
  ],
})
export class ShoelaceModule {}
